var MuiInputLabel = {
    /* put your new default props here */
    shrink: true,
};
export default MuiInputLabel;
//# sourceMappingURL=MuiInputLabel.js.map